import { SYMBOL_NUMBER_TYPE } from "@visactor/vrender-core";

import { PickerBase } from "../common/base";

export class DefaultMathSymbolPicker extends PickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "symbol", this.numberType = SYMBOL_NUMBER_TYPE;
    }
}
//# sourceMappingURL=symbol-picker.js.map
